import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { GenericFormPage } from '../../../components/generic';
import { useKnowledgeBaseCategory, useKnowledgeBaseCategoriesList, KnowledgeBaseCategory } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
  formLayout,
} from './config';

const Form: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const currentId = id != null ? parseInt(id, 10) : NaN;
  const { data: categories } = useKnowledgeBaseCategoriesList();

  const configWithParentOptions = useMemo(() => {
    const list = (categories || []).filter((c) => c.id !== currentId || Number.isNaN(currentId));
    const parentOptions = [
      { value: '', label: 'None (top-level category)' },
      ...list.map((c) => ({
        value: c.id.toString(),
        label: c.parentId ? `↳ ${c.name}` : c.name,
      })),
    ];

    const fields = moduleConfig.fields.map((field) => {
      if (field.name === 'parentId') {
        return { ...field, options: parentOptions };
      }
      return field;
    });

    return { ...moduleConfig, fields };
  }, [categories, currentId]);

  return (
    <GenericFormPage<KnowledgeBaseCategory>
      useData={useKnowledgeBaseCategory}
      config={{
        ...configWithParentOptions,
        getInitialFormData,
        mapItemToFormData,
        formLayout,
      }}
    />
  );
};

export default Form;
